export default __webpack_public_path__ + "4a906c90dce190946355c73a1fc1672a.png";